// expose modal if form has errors or submission info
let $formModalLabel = $('.modal .ErrorLabel, .modal .InfoLabel');
if ($formModalLabel) {
  let modalId = $formModalLabel.closest('.modal').attr('id')
  $('button[data-target$="' + modalId + '"]').trigger('click');
}

// update calendar picker icon class
$('.date-time-picker i').removeClass().addClass('far fa-calendar-plus');
